import { StateCreator, create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import { shared } from './shared-middleware'
import { storage } from './storage-middleware'

type StoreOptions = {
  persist?: boolean
  shared?: boolean
  onHydrate?: (state: unknown) => void
}

export const createStore = <T>(
  name: string,
  stateCreator: StateCreator<T, [['zustand/immer', never]], []>,
  storeOptions: StoreOptions = { persist: false, shared: false },
) => {
  const zName = `z-${name}`
  const withImmer = immer(stateCreator)
  const persistConfig = {
    name: zName,
    storage: createJSONStorage(() => storage),
    onRehydrateStorage: storeOptions.onHydrate,
  }
  if (storeOptions.persist || storeOptions.shared) {
    if (storeOptions.persist && !storeOptions.shared) {
      return create<T>()(persist(withImmer, persistConfig))
    }

    if (storeOptions.shared && !storeOptions.persist) {
      // Pass the name to the shared middleware
      return create<T>()(shared(withImmer, { name }))
    }
    if (storeOptions.shared && storeOptions.persist) {
      // Pass the name to the shared middleware
      return create<T>()(shared(persist(withImmer, persistConfig), { name: zName }))
    }
  }
  return create<T>()(withImmer)
}
